export default {
	dashboard: "Dashboard",
	users: "Usuários",
	consultants: "Consulentes",
	mediums: "Corrente",
	functions: "Funções",
	spiritualLines: "Linhas Espirituais",
	guides: "Guias Espirituais",
	orixas: "Orixás",
	ritualTypes: "Tipos de Rituais",
	attendanceTypes: "Tipos de Atendimento",
	rituals: "Rituais",
	journeyStages: "Jornadas",
	templeSettings: "Configurações",
	templeInvites: "Convites",
	displayMessages: "Display / TV",
	wisdomQuotes: "Frases de Sabedoria",
	import: "Importação",
	billing: "Meu Plano",
	manual: "Manual",
	support: "Suporte",
	logout: "Sair",
};
